import React, {PropTypes} from 'react';

class Overlay extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    toggle: PropTypes.string
  };

  render() {
    return (
      <div className={"overlay" + " " + this.props.toggle} data-value="overlay"
           onClick={(e) => this.props.onClick(e)}/>
    );
  }
}


export default Overlay;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/Overlay.js
 **/